import {axiosInstance} from "../../../config/axiosInstance";
import {CONSTANTS} from "../../../constants/constants";

export const CAR_API = {
  getCarDetail: async ({slug, currency}) => (
    await axiosInstance.get(`${CONSTANTS?.API?.API_VERSION?.V1}/car/details`, { params: {slug, currency} })
  ),
};